const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1367,
    xl: 2560,
  },
};

export default breakpoints;
